<template>
    <div>
        <div
            @click="show = !show"
            class="
                c-activity-session
                btn btn-text
                p-0
                text-primary
                font-weight-bold
                my-3
                text-left
            "
        >
            <template v-if="dfrom == dto"
                >{{ name }}: {{ dfrom | formatDate }}
            </template>
            <template v-else
                >{{ name }}: {{ dfrom | formatDate }} - {{ dto | formatDate }}
            </template>
        </div>
        <br />
        <div v-show="show" class="overflow-hidden">
            <session-calendar :term="term"></session-calendar>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "term", "count", "dfrom", "dto"],
    data: function () {
        return {
            show: false,
        };
    },
    methods: {},
};
</script> 
